<div
  class="visibility-card"
  *ngIf="!loading"
  [class.greyed-out]="!accountActivated"
  [matTooltip]="!accountActivated ? ('global.tooltip_visibility_not_activated' | translate) : ''"
  matTooltipClass="tooltip-multiline"
  matTooltipPosition="above"
>
  <h3 class="visibility-title">{{ 'global.profile_visibility_heading' | translate }}</h3>

  <div class="toggle-row">
    <mat-slide-toggle
      [checked]="visibleToEmployers"
      (change)="toggleVisibility()"
      [disabled]="!accountActivated"
      color="primary"
      [attr.aria-label]="'global.profile_visibility_heading' | translate"
    ></mat-slide-toggle>
  </div>

  <div class="info-box" *ngIf="visibleToEmployers">
    <div class="info-box-header">
      <span class="info-check-icon" aria-hidden="true">&#10003;</span>
      <span class="info-box-title">{{ 'global.profile_is_anonymous' | translate }}</span>
    </div>
    <p class="info-box-text">
      {{ 'global.profile_anonymous_explanation' | translate }}
      <a href="#" class="privacy-link">{{ 'global.more_about_privacy' | translate }}</a>
    </p>
  </div>
</div>
